import React from 'react';
import { ToastType } from '../Toast';
import { ToastLayerToast } from '../ToastLayer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListingToast = _ref => {
  let {
    toastMessage,
    onClose,
    visibilityTime = 8000
  } = _ref;
  const toastTitle = toastMessage.Type === ToastType.Warning ? 'Error' : 'Information';
  return /*#__PURE__*/_jsx(ToastLayerToast, {
    isOpen: true,
    title: toastTitle,
    type: toastMessage.Type,
    visibilityTime: visibilityTime,
    onClose: onClose,
    subText: toastMessage.Message,
    dataId: getDataIdByToastMessageType(toastMessage.Type)
  });
};
const getDataIdByToastMessageType = type => {
  switch (type) {
    case ToastType.Info:
      return 'info-toast-message';
    case ToastType.Success:
      return 'success-toast-message';
    case ToastType.Warning:
      return 'error-toast-message';
    default:
      return '';
  }
};